import { useAuth } from '../context/AuthContext';
import { useRouter } from '../context/RouterContext';
import UserAvatar from './UserAvatar';

/**
 * UserInfo - Modern user info display component
 * Shows avatar, name, and email with improved typography
 */
function UserInfo({ user, showEmail = true }) {
  // Get display name - prefer name over nickname over email
  const getDisplayName = (user) => {
    if (user.name && user.name !== user.email) {
      return user.name;
    }
    if (user.nickname) {
      return user.nickname;
    }
    if (user.email) {
      // If only email, show part before @
      return user.email.split('@')[0];
    }
    return 'User';
  };

  const displayName = getDisplayName(user);

  return (
    <div style={{ 
      display: 'flex', 
      alignItems: 'center', 
      gap: '12px',
      minWidth: 0, // Allow text truncation
    }}>
      <UserAvatar user={user} size="md" />
      <div style={{ 
        display: 'flex', 
        flexDirection: 'column', 
        minWidth: 0, // Allow text truncation
        maxWidth: '200px'
      }}>
        <span style={{ 
          fontSize: '14px', 
          fontWeight: '500',
          color: '#1f2937',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        }}>
          {displayName}
        </span>
        {showEmail && user.email && (
          <span style={{ 
            fontSize: '12px', 
            color: '#6b7280',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          }}>
            {user.email}
          </span>
        )}
      </div>
    </div>
  );
}

/**
 * AppHeader - Reusable header component for all pages
 * DRY component to avoid repetition across pages
 */
function AppHeader({ showBackButton = false, backgroundColor = 'white' }) {
  const { user, logout } = useAuth();
  const { navigate } = useRouter();

  return (
    <nav className="landing-nav" style={{ backgroundColor }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
        <img 
          src="/lendport_logo_icon_text.svg" 
          alt="Lendport" 
          className="landing-logo"
          style={{ cursor: 'pointer' }}
          onClick={() => navigate('/')}
        />
        {showBackButton && (
          <button
            onClick={() => navigate('/')}
            style={{
              padding: '6px 12px',
              background: 'transparent',
              border: '1px solid #d1d5db',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '13px',
              color: '#374151',
              transition: 'all 0.2s',
            }}
          >
            ← Back
          </button>
        )}
      </div>
      
      {user && (
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          <UserInfo user={user} showEmail={true} />
          <button 
            onClick={logout} 
            className="landing-logout-btn"
            style={{
              padding: '6px 16px',
              background: 'white',
              border: '1px solid #d1d5db',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '13px',
              color: '#374151',
              transition: 'all 0.2s',
            }}
          >
            Logout
          </button>
        </div>
      )}
    </nav>
  );
}

export default AppHeader;
export { UserInfo, UserAvatar };
